import styled from 'styled-components'

export const SpecificationDiv = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  justify-content: space-between;
  width: 0;
  grid-row: 1;
  color: #fff;

  @media (min-width: 768px) and (min-height: 681px){
    max-height: 280px;
  }

  @media (min-width: 768px) and (min-height: 420px) and (max-height: 680px){
    max-height: 100px;
  }

  > div {
    display: flex;
    flex-direction: column;
    width: 120px;
    margin-bottom: 8px;
    margin-right: 0px;

    @media (min-width: 768px) {
      margin-right: 36px;
    }
  }

  .info {
    font-size: 13px;
    margin-left: 10px;
  }

  @media (max-width: 600px) {
    padding-top: 15px;
    height: 220px;
    grid-row: 4;
  }
`;